import { isCanonicalDeckSlug } from '../../shared/deck.ts';

import type { DeckScope } from '../../shared/deck.ts';

export type DeckRoute = { deckSlug: string; scope: DeckScope };

function decodeCanonicalSegment(encoded: string): string | null {
  let value: string;
  try {
    value = decodeURIComponent(encoded);
  } catch {
    return null;
  }
  if (encodeURIComponent(value) !== encoded || !isCanonicalDeckSlug(value))
    return null;
  return value;
}

export function deckRouteFromPath(pathname: string): DeckRoute | null {
  const segments = pathname.split('/').slice(1);
  if (
    segments.length !== 2 &&
    segments.length !== 4 &&
    segments.length !== 6 &&
    segments.length !== 8
  )
    return null;
  const deckSlug = decodeCanonicalSegment(segments[1]!);
  if (!deckSlug || segments[0] !== 'deck') return null;
  const scope: DeckScope = {};
  const expectedKinds = ['section', 'unit', 'topic'];
  for (let index = 2; index < segments.length; index += 2) {
    const value = decodeCanonicalSegment(segments[index + 1]!);
    if (!value) return null;
    const kind = segments[index];
    if (kind !== expectedKinds[index / 2 - 1]) return null;
    if (kind === 'section' && !scope.sectionSlug) scope.sectionSlug = value;
    else if (kind === 'unit' && !scope.unitSlug) scope.unitSlug = value;
    else if (kind === 'topic' && !scope.topicSlug) scope.topicSlug = value;
    else return null;
  }
  return { deckSlug, scope };
}

export function deckSlugFromPath(pathname: string): string | null {
  return deckRouteFromPath(pathname)?.deckSlug ?? null;
}

export function isDeckPath(pathname: string): boolean {
  return deckSlugFromPath(pathname) !== null;
}
